export class AutomatedActionApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async sendNoi({ applicationId }) {
    return this.#http.post(`/AutomatedAction/application/${applicationId}/runforapp`, null);
  }
}
